export const adminPreviewItemKey = preview => {
  if (!preview?.type || preview?.item?.id === undefined || preview?.item?.id === null) return null;
  return `${preview.type}:${preview.item.id}`;
};

const imageUrl = image => String(image?.url || image || "").trim();

export const buildAdminPlaceImageGallery = (place, reviews = []) => {
  if (!place) return [];
  const placeId = Number(place.id);
  const matchingReviews = (Array.isArray(reviews) ? reviews : []).filter(review => Number(review?.placeid ?? review?.placeId) === placeId);
  const urls = [
    imageUrl(place.image),
    ...matchingReviews.flatMap(review => (Array.isArray(review?.imagenes) ? review.imagenes : []).map(imageUrl)),
  ].filter(Boolean);
  return [...new Set(urls)];
};

export const captureAdminPreviewContext = ({
  preview,
  tab,
  scrollTop = 0,
  pageLugaresAprob = 1,
  pageResenasAprob = 1,
  pageUsuarios = 1,
} = {}) => ({
  itemKey: adminPreviewItemKey(preview),
  tab: tab || "lugares",
  scrollTop: Number.isFinite(Number(scrollTop)) ? Math.max(0, Number(scrollTop)) : 0,
  pageLugaresAprob,
  pageResenasAprob,
  pageUsuarios,
});

export const restoreAdminPreviewContext = ({ context, getScrollElement, onTab, onPages, raf = cb => window.requestAnimationFrame(cb) } = {}) => {
  if (!context) return false;
  onTab?.(context.tab);
  onPages?.({
    pageLugaresAprob: context.pageLugaresAprob,
    pageResenasAprob: context.pageResenasAprob,
    pageUsuarios: context.pageUsuarios,
  });
  raf(() => {
    const scrollElement = getScrollElement?.();
    if (scrollElement) scrollElement.scrollTop = context.scrollTop;
  });
  return true;
};
